<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option
          v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id"
          :value="enumeraciones.tiposDeSelect.Seleccione.Id"
        >{{tipo.Nombre}} una entidad federativa</option>
        <option
          v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id"
          :value="enumeraciones.tiposDeSelect.Todos.Id"
        >{{enumeraciones.tiposDeSelect.Todas.Nombre}} las entidades federativas</option>
        <option
          v-for="EntidadFederativa in LocalEntidadesFederativas"
          v-bind:key="EntidadFederativa.EntidadFederativaId"
          v-bind:value="EntidadFederativa.EntidadFederativaId"
        >{{EntidadFederativa.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import comun from "@/../static/js/comun";
import api from "@/../static/js/api";
import axios from "axios";

export default {
  data() {
    return {
      idDelModelo: null,
      enumeraciones,
      comun,
      LocalEntidadesFederativas: []
    };
  },
  computed: {
    EntidadFederativaId() {
      return this.$store.state.PJ_Catalogos_011EntidadFederativaId;
    }
  },
  props: {
    parametros: Object,
    valorDefinido: Number,
    idDelInput:String,    
    prefijo: Number,
    tipo: {
      Id: Number,
      Nombre: String
    }
  },
  mounted() {
    if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer011EntidadFederativa", parametros);
  },
  created() {
    this.cargaCatalogoDeEntidadesFederativas();
  },
  methods: {
    cargaCatalogoDeEntidadesFederativas: function() {
      let peticion = {
        EsPrueba: this.enumeraciones.EsPrueba
      };
      axios
        .post(
          api.conexion + api.PJ.catalogos.C011EntidadesFederativas,
          peticion
        )
        .then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.error(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            this.LocalEntidadesFederativas =
              respuesta.data.EntidadesFederativas;
          }
        })
        .catch(e => {
          console.error("Excepción del servidor" + e);
        });
    },
    cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const parametros =
        {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogo_Establecer011EntidadFederativa",parametros);
        this.$emit("valorParaElPadre",evento);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/011EntidadesFederativas.vue